// extracted by mini-css-extract-plugin
export var colorSquare = "_q9-0";
export var danger = "_q9-5";
export var lightPink = "_q9-8";
export var neutralBlue = "_q9-7";
export var neutralYellow = "_q9-6";
export var normal = "_q9-1";
export var primary = "_q9-2";
export var primaryLight = "_q9-3";
export var solidBlack = "_q9-g";
export var solidGreen = "_q9-b";
export var solidLightBlue = "_q9-d";
export var solidNavy = "_q9-c";
export var solidOrange = "_q9-f";
export var solidPink = "_q9-e";
export var solidRed = "_q9-9";
export var solidYellow = "_q9-a";
export var success = "_q9-4";